export const MEDIA = {
  logo: "https://img1.wsimg.com/isteam/ip/f7fe6576-a77b-4d71-b5e1-10dac05c50f3/Golden%20Wolf%20Foundation%20V2-01.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/3d15d422-69f9-45d2-9ccf-66bab17f5af8/images/75cd6cf28bc6fd116e58a1e825832d010f3f0d026ecaf0bd63352f268cddc7b3.jpeg",
  veteranDog: "https://images.unsplash.com/photo-1781552100479-3477d78d6e82?crop=entropy&cs=srgb&fm=jpg&q=85",
  trainer: "https://images.unsplash.com/photo-1550519047-39665d0e874c?crop=entropy&cs=srgb&fm=jpg&q=85",
  mural: "https://images.unsplash.com/photo-1785732709462-a98eeb66356a?crop=entropy&cs=srgb&fm=jpg&q=85",
  dog1: "https://images.unsplash.com/photo-1770751347681-9d3585263a71?crop=entropy&cs=srgb&fm=jpg&q=85",
  dog2: "https://images.unsplash.com/photo-1772320129689-163dae9b323d?crop=entropy&cs=srgb&fm=jpg&q=85",
  gear: "https://images.pexels.com/photos/3981763/pexels-photo-3981763.jpeg",
  food: "https://images.unsplash.com/photo-1714068691210-073dc52c6c1d?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const TAGLINE = "Strength. Service. Purpose.";
export const CAMPAIGN_TAGLINE = "You Can't Burn Without Fire.";
export const SECONDARY = "Train a Dog. Transform a Veteran. Build a Legacy.";
